/**
 * Best-effort boolean flags in sessionStorage.
 *
 * Every access is guarded: sessionStorage throws in restricted contexts (blocked storage, some
 * private-browsing modes), and the auth flow must degrade rather than break when it is unavailable.
 * An unreadable flag reads as "not set".
 */

export function markSessionFlag(key: string): void {
  try {
    sessionStorage.setItem(key, "1");
  } catch {
    // sessionStorage may be unavailable in restricted contexts.
  }
}

export function hasSessionFlag(key: string): boolean {
  try {
    return sessionStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

export function clearSessionFlag(key: string): void {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // sessionStorage may be unavailable in restricted contexts.
  }
}
